import React from "react";
import { Youtube } from "lucide-react";

// Brand icons not available in lucide-react are drawn as custom SVGs.
export function XIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
    </svg>
  );
}

export function TikTokIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07Z" />
    </svg>
  );
}

export function RedditIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0Zm5.01 4.74c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25c-.68 0-1.23-.54-1.25-1.21l-2.05-.43-.63 2.97c1.43.06 2.72.5 3.66 1.16.24-.24.57-.39.94-.39.74 0 1.34.6 1.34 1.34 0 .53-.31.99-.77 1.21a2.7 2.7 0 0 1 .03.42c0 2.14-2.49 3.87-5.56 3.87-3.08 0-5.56-1.73-5.56-3.87 0-.14 0-.29.03-.43-.44-.23-.74-.68-.74-1.2 0-.74.6-1.34 1.34-1.34.36 0 .69.14.93.38.94-.66 2.24-1.1 3.68-1.16l.7-3.31c.02-.08.06-.14.12-.18.07-.04.14-.05.22-.04l2.31.49c.17-.31.5-.53.88-.53Zm-6.86 5.9c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25Zm3.72 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25Zm-3.75 3.66a.34.34 0 0 0-.24.58c.55.55 1.6.6 1.91.6.31 0 1.36-.05 1.91-.6a.35.35 0 0 0 .09-.24.35.35 0 0 0-.35-.34.34.34 0 0 0-.23.09c-.35.34-1.09.47-1.42.47-.33 0-1.08-.13-1.42-.47a.34.34 0 0 0-.24-.09Z" />
    </svg>
  );
}

export function TelegramIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M11.94 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0h-.06Zm5.03 8.16c-.13 1.39-.7 4.77-1 6.33-.12.66-.36.88-.6.9-.5.05-.9-.33-1.38-.65-.76-.5-1.19-.81-1.93-1.3-.85-.56-.3-.87.19-1.37.13-.13 2.32-2.13 2.36-2.31.01-.02.01-.11-.04-.15s-.13-.03-.19-.02c-.08.02-1.38.88-3.89 2.58-.37.25-.7.38-1 .37-.33-.01-.96-.19-1.43-.34-.58-.19-1.04-.29-1-.61.02-.17.25-.34.69-.52 2.72-1.18 4.53-1.96 5.43-2.35 2.58-1.07 3.12-1.26 3.47-1.26.08 0 .25.02.36.11.09.07.12.17.13.24.01.06.03.19.02.29Z" />
    </svg>
  );
}

export const SOCIAL_LINKS = [
  { name: "X", Icon: XIcon, href: "https://x.com/sharkbowlgames" },
  { name: "TikTok", Icon: TikTokIcon, href: "https://www.tiktok.com/@sharkbowlgames" },
  { name: "YouTube", Icon: Youtube, href: "https://www.youtube.com/@sharkbowlgames5885" },
];
